import React from "react"
import "./Comments.scss"
import { MongoTimeConvert } from "../converters/timeConverters"
import { connect } from "react-redux"

class Comment extends React.Component {
	constructor(props) {
		super(props)
		this.edit = this.edit.bind(this)
		this.save = this.save.bind(this)
		this.remove = this.remove.bind(this)
		this.state = { editing: false }
	}

	edit() {
		this.setState({ editing: true })
	}

	save() {
		console.log(this.newText.value)
		var newText = this.newText.value
		this.props.updateCommentFromBoard(newText, this.props.index)
		this.setState({ editing: false })
	}

	remove() {
		this.props.removeCommentFromBoard(this.props.index)
	}

	renderNormalMode() {
		return (
			<div className='commentContainer'>
				<div className='commentText'>{this.props.children}</div>
				<button onClick={this.edit} className='btn btn-comment'>
					<span className='fa fa-pencil fa-2x'></span>
				</button>
				<button onClick={this.remove} className='btn btn-comment'>
					<span className='fa fa-trash fa-2x'></span>
				</button>
			</div>
		)
	}

	renderEditingMode() {
		return (
			<div className='commentContainer'>
				<div className='commentText'>
					<textarea
						ref={(input) => {
							this.newText = input
						}}
						onChange={this.handleChange}
						defaultValue={this.props.children}
					></textarea>
				</div>

				<button onClick={this.save} className='btn-comment'>
					<span className='fa fa-floppy-o fa-2x'></span>
				</button>
			</div>
		)
	}

	render() {
		if (this.state.editing) {
			return this.renderEditingMode()
		} else {
			return this.renderNormalMode()
		}
	}
}

class VideoComments extends React.Component {
	constructor(props) {
		super(props)
		this.displayComments = this.displayComments.bind(this)
		this.updateComment = this.updateComment.bind(this)
		this.removeComment = this.removeComment.bind(this)
		this.addNewComment = this.addNewComment.bind(this)
		this.state = { comment: "", userName: "" }

		this.handleCommentChange = (e) => {
			console.log(e.target.value)
			this.setState({
				comment: e.target.value,
			})
		}
		this.handleUserNameChange = (e) => {
			console.log(e.target.value)
			this.setState({
				userName: e.target.value,
			})
		}
	}

	removeComment(idx) {
		var arr = this.state.comments
		arr.splice(idx, 1)
		this.setState({ comments: arr })
	}

	updateComment(newText, idx) {
		var arr = this.state.comments
		arr[idx] = newText
		this.setState({ comments: arr })
	}

	addNewComment() {
		var newText = "#shareCommentText".val()
		console.log(newText)
		if (newText !== "") {
			var arr = this.state.comments
			arr.push(newText)
			this.setState({ comments: arr })
		} else alert("Please write a comment to share!")
	}

	displayComments(text, i) {
		return (
			<Comment
				key={i}
				index={i}
				removeCommentFromBoard={this.removeComment}
				updateCommentFromBoard={this.updateComment}
			>
				{text}
			</Comment>
		)
	}
	render() {
		return (
			<div className='board'>
				<div
					style={{
						display: !this.props.currentUser.fullName
							? "block"
							: "none",
					}}
					className='commentName'
				>
					<div>Post as Guest</div>
					<input
						type='text'
						placeholder='Please write name to comment as a Guest'
						onChange={this.handleUserNameChange}
					></input>
				</div>
				<div className='shareCommentContainer'>
					<textarea
						onChange={this.handleCommentChange}
						id='shareCommentText'
						name='comment'
						placeholder='Please Write a comment.'
					></textarea>
					<button
						onClick={() =>
							this.props.addComments(
								this.props.video,
								this.state.comment,
								this.state.userName
							)
						}
						type='submit'
						className='btn btn-success'
					>
						{" "}
						POST
					</button>
				</div>

				{/* {this.state.comments.map(this.displayComments)} */}
				{
					this.props.userComment.length > 0 &&
					<div className='commentContainer'>
						{this.props.userComment.map((item) => (
							<div>
								<div className='userNameAndIcon'>
									<div className='imageIcon'>
										<img
											src={require("../icons/iconuser.png")}
											alt="user profile"
										></img>
									</div>
									<div className='ownerName'>
										{item.user}
										<span>
											{" "}
											{MongoTimeConvert(item.createdAt)}
										</span>{" "}
									</div>
								</div>
								<div className='commentText'>{item.comment}</div>
							</div>
						))}
					</div>
				}
			</div>
		)
	}
}

function mapStateToProps({ currentUser }) {
	return {
		currentUser: currentUser,
	}
}

export default connect(mapStateToProps)(VideoComments)
